import { createSlice } from "@reduxjs/toolkit";
import {
  getEmailsByFilter,
  getNotificationByExternalId,
  getNotificationById,
  getNotificationsByFilter,
  getPushesByFilter,
} from "./notificationsActionAsync";
import {
  ContactFilters,
  ContactResponceEntity,
  NoticeEntity,
  NoticeResponceEntity,
} from "common/interfaces/notifications";
import { IDeepLinks } from "common/interfaces/IDeepLinks";

export type NotificationsState = {
  isLoading: boolean;
  count: number;
  items?: NoticeResponceEntity[];
  notice?: NoticeResponceEntity;
  deepLinks?: IDeepLinks[];
  contactsItems?: ContactResponceEntity[];
  contactsCount: number;
};

export const notificationsInitialState: NotificationsState = {
  isLoading: false,
  count: 0,
  contactsCount: 0,
};

export const { actions: notificationsActions, reducer: notificationsReducer } = createSlice({
  name: "notifications",
  initialState: notificationsInitialState,
  reducers: {
    resetNotice(state) {
      state.notice = undefined;
    },

    setDeepLinks(state, { payload }) {
      state.deepLinks = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationsByFilter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNotificationsByFilter.fulfilled, (state, { payload }) => {
        state.count = payload.count;
        state.items = payload.items;
        state.isLoading = false;
      })
      .addCase(getNotificationsByFilter.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getNotificationByExternalId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNotificationByExternalId.fulfilled, (state, { payload }) => {
        state.notice = payload;
        state.isLoading = false;
      })
      .addCase(getNotificationByExternalId.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getNotificationById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNotificationById.fulfilled, (state, { payload }) => {
        console.log("payload", payload);
        state.notice = payload;
        state.isLoading = false;
      })
      .addCase(getNotificationById.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getEmailsByFilter.fulfilled, (state, { payload }) => {
        state.contactsCount = payload.count;
        state.contactsItems = payload.items;
        state.isLoading = false;
      })
      .addCase(getEmailsByFilter.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getEmailsByFilter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPushesByFilter.fulfilled, (state, { payload }) => {
        state.contactsCount = payload.count;
        state.contactsItems = payload.items;
        state.isLoading = false;
      })
      .addCase(getPushesByFilter.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPushesByFilter.rejected, (state) => {
        state.isLoading = false;
      });
  },
});
